import React from 'react';
import FormatMessage from '../../messages/FormatMessage';
import ExpansionPanel from '../ExpansionPanel/ExpansionPanel';

type Props = {
  titleMessageId: string;
  children: React.ReactNode;
  expansionPanel?: boolean;
};

const HmiCard: React.FC<Props> = ({
  titleMessageId,
  expansionPanel,
  children,
}) => {
  if (expansionPanel) {
    return <ExpansionPanel title={titleMessageId}>{children}</ExpansionPanel>;
  } else {
    return (
      <div className={'hmi-panel'}>
        <div className={'hmi-panel-title'}>
          <FormatMessage id={titleMessageId} />
        </div>
        <div className={'hmi-panel-content'}>{children}</div>
      </div>
    );
  }
};

export default HmiCard;
